export default __webpack_public_path__ + "static/media/thumbnail-rocket.fd6d6638.webp";